import { Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RiskAnalysis } from '../risk-analysis/risk-analysis.component';

export type ValidationFailure = {
    field: string;
    type: string;
    description: string;
};

@Component({
    selector: 'app-validation-failures-modal',
    templateUrl: './validation-failures-modal.component.html',
    styleUrl: './validation-failures-modal.component.scss'
})
export class ValidationFailuresModalComponent {
    private readonly modal = inject(NgbActiveModal);

    public validationFailures: ValidationFailure[] = [];
    public riskAnalysis: RiskAnalysis | null = null;

    public closeModal() {
        this.modal.dismiss();
    }
}
